import { CollectionsIcon } from 'ui/icons/CollectionsIcon'
import { SCOPE_OPTIONS } from './typing'

import { IconBarcode, IconCube, IconTag } from '@vtex/admin-ui'
import { IconBranch } from 'ui'

type IconComponentType = {
  icon: SCOPE_OPTIONS
}

const IconsMap = {
  [SCOPE_OPTIONS.SKUS]: IconBarcode,
  [SCOPE_OPTIONS.COLLECTIONS]: CollectionsIcon,
  [SCOPE_OPTIONS.PRODUCTS]: IconCube,
  [SCOPE_OPTIONS.CATEGORIES]: IconBranch,
  [SCOPE_OPTIONS.BRANDS]: IconTag,
}

export const IconComponent = (props: IconComponentType) => {
  const Icon = IconsMap[props.icon]
  return <Icon />
}
